<template>
    <el-table :data="tableData" stripe style="width: 100%" :cell-style="{'text-align':'center'}">
        <el-table-column prop="openNum" label="期号" align="center">
        </el-table-column>
        <el-table-column prop="openTime" label="时间" align="center">
        </el-table-column>
        <el-table-column prop="result" label="号码" align="center">
            <template slot-scope="scope">
                {{ getResult(scope.row.result) }}
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    props: {
        tableData: {
            type: Array,
            default: null,
            require: true
        }
    },
    methods: {
        getResult(data) {
            if (data != null && data.length == 3) {
                return data[0] + "+" + data[1] + "+" + data[2] + "=" + (data[0] + data[1] + data[2])
            }
            return "未开奖"
        }
    }
}
</script>